import { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export function LanguageSelector() {
  const { i18n } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const languages = [
    { code: 'en', label: 'EN', native: 'English' },
    { code: 'zh-CN', label: '简', native: '简体中文' },
    { code: 'zh-TW', label: '繁', native: '繁體中文' },
    { code: 'ja', label: '日', native: '日本語' },
    { code: 'ko', label: '한', native: '한국어' },
    { code: 'es', label: 'ES', native: 'Español' },
    { code: 'pt', label: 'PT', native: 'Português' },
    { code: 'ru', label: 'RU', native: 'Русский' },
    { code: 'fi', label: 'FI', native: 'Suomi' },
    { code: 'sv', label: 'SV', native: 'Svenska' },
    { code: 'et', label: 'ET', native: 'Eesti' },
    { code: 'da', label: 'DA', native: 'Dansk' },
    { code: 'de', label: 'DE', native: 'Deutsch' },
    { code: 'fr', label: 'FR', native: 'Français' },
    { code: 'it', label: 'IT', native: 'Italiano' },
    { code: 'nb', label: 'NO', native: 'Norsk' },
    { code: 'vi', label: 'VI', native: 'Tiếng Việt' },
    { code: 'ar', label: 'AR', native: 'العربية' },
    { code: 'he', label: 'HE', native: 'עברית' },
    { code: 'yi', label: 'YI', native: 'ייִדיש' },
    { code: 'id', label: 'ID', native: 'Bahasa Indonesia' },
    { code: 'hi', label: 'HI', native: 'हिन्दी' }
  ]

  const currentLang = languages.find(l => l.code === i18n.language) || languages[0]

  // 点击外部关闭下拉菜单
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-9 h-9 flex items-center justify-center rounded-lg bg-zinc-800/50 hover:bg-zinc-700 text-zinc-300 hover:text-white transition-colors border border-zinc-700 font-bold text-sm uppercase"
        aria-label="Select Language"
      >
        {currentLang.label}
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 max-h-80 overflow-y-auto bg-zinc-900 border border-zinc-700 rounded-lg shadow-xl z-50 animate-pop">
          <div className="py-1">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => {
                  i18n.changeLanguage(lang.code)
                  setIsOpen(false)
                }}
                className={`
                  w-full px-4 py-2 flex items-center justify-between gap-3 text-sm font-medium
                  hover:bg-zinc-800 transition-colors
                  ${i18n.language === lang.code ? 'text-brand-orange bg-zinc-800/50' : 'text-zinc-400'}
                `}
              >
                <span>{lang.native}</span>
                <span className="text-xs font-bold uppercase text-zinc-600">{lang.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
